import React, { useMemo } from 'react';
import styles from './SavedFilter.module.scss';
import { CardDesign } from '../../../../../../components/CardDesign';
import { Icon, Spin, Tag } from 'antd';
import useSavedFilters from '../hooks/useSavedFilters';

export const FILTER_NAME_VISIBLE_LENGTH = 25;

export const shortFilterName = (name) => {
  return name.length > FILTER_NAME_VISIBLE_LENGTH
    ? `${name.slice(0, FILTER_NAME_VISIBLE_LENGTH).trim()}...`
    : name;
};

const SavedFilter = () => {
  const {
    filters,
    chosenFilterId,
    isFetching,
    isBusy,
    applyFilter,
    confirmDeleteFilter,
  } = useSavedFilters();

  const savedFiltersList = useMemo(() => {
    return filters.map((filter) => (
      <Tag
        color={chosenFilterId === filter.id ? '#0995ED' : '#E9E9E9'}
        className={styles.tag}
        onClick={() => applyFilter(filter.id)}
        key={filter.id}
        closable
        onClose={(e) => confirmDeleteFilter(e, filter.id)}
      >
        <span
          style={{ color: chosenFilterId === filter.id ? 'white' : 'black' }}
          className={styles.textTag}
        >
          {isBusy ? <Icon type="loading" /> : shortFilterName(filter.name)}
        </span>
      </Tag>
    ));
  }, [filters, chosenFilterId]);

  return (
    <CardDesign style={{ backgroundColor: 'white' }}>
      <CardDesign.Header heading="Сохраненные фильтры" />

      <CardDesign.Body>
        <Spin
          size="small"
          spinning={isFetching}
        >
          <div className={styles.savedFiltersTags}>
            {savedFiltersList.length ? (
              savedFiltersList
            ) : (
              <div className={styles.text}>
                <div style={{ fontWeight: 500 }}>
                  Вы еще не добавили ни одного набора фильтров
                </div>
                <div>Нажмите “Сохранить фильтр”, чтобы создать собственный</div>
              </div>
            )}
          </div>
        </Spin>
      </CardDesign.Body>
    </CardDesign>
  );
};

export default SavedFilter;
